<template>
  <RevButtonBase
    class="rounded-sm body-1-bold box-border flex gap-4 text-nowrap border px-12 py-8 hover:bg-action-default-min-hover motion-safe:transition-colors motion-safe:duration-200 motion-safe:ease-in"
    :to="buybackHomeRoute"
    :tracking
  >
    <BuybackIcon />
    <span>
      {{ i18n(translations.tradeIn) }}
    </span>
  </RevButtonBase>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import BuybackIcon from '@backmarket/nuxt-layer-buyback/app/scopes/offer/components/BuybackIcon/BuybackIcon.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'

import translations from './TradeInButton.translations'

const resolveLocalizedRoute = useRouteLocationWithLocale()
const i18n = useI18n()

const route = useRoute()

const buybackHomeRoute = resolveLocalizedRoute({
  name: CMS.BUYBACK,
  params: {
    pageName: 'home',
  },
})

const tracking = computed((): Record<string, string> => {
  const value = route.name?.toString()

  return value
    ? { name: 'buyback', zone: 'header', value }
    : { name: 'buyback', zone: 'header' }
})
</script>
